export default "__VITE_ASSET__CwnlDFaZ__"